var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{attrs:{"fields":[
      {name: 'authenticationCode', type: 'number'}
    ],"submitText":_vm.modes[_vm.mode].buttonText,"noBackground":true,"onSubmit":this.authenticate,"width":'400px'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }